export function initToggleSwitch() {
  document.addEventListener('click', e => {
    const toggle = e.target.closest('[data-toggle-switch]');
    if (!toggle) return;
    toggle.classList.toggle('active');
    const input = toggle.querySelector('input[type="checkbox"]');
    if (input) input.checked = toggle.classList.contains('active');
    toggle.setAttribute('aria-checked', toggle.classList.contains('active').toString());
  });
}
